export enum RouteNames {
  HOME = 'home',

  API_CLIENTS_PARENT = 'api-clients-parent',
  API_CLIENTS = 'api-clients',
  API_CLIENT = 'api-client',
  EDIT_API_CLIENT = 'edit-api-client',
  NEW_API_CLIENT = 'new-api-client',

  AUDIT_LOG = 'audit-log',

  VISIBILITY_MANAGEMENT = 'visibility-management',
  VISIBILITY_MANAGEMENT_FACILITY = 'visibility-management-facility',

  FACILITY = 'facility',
  EDIT_FACILITY = 'edit-facility',
  NEW_FACILITY = 'new-facility',

  NOT_FOUND = 'not-found',

  FORBIDDEN = 'forbidden',

  NOA_SPACE = 'noa-space',
  NOA_SPACE_VISIBILITY_MANAGEMENT = 'noa-space-visibility-management',
  NOA_SPACE_VISIBILITY_MANAGEMENT_FACILITY = 'noa-space-visibility-management-facility',

  LOGOUT = 'logout',
}
